import { TUser } from "../models";
import Roles from "../models/roles";

/**
 * Check if the current user is a Super Admin or General Admin
 * @param user - The user object from Redux state
 * @returns true if user is Super Admin or General Admin, false otherwise
 */
export const isSuperAdmin = (user: TUser | null): boolean => {
  return (
    (user?.role?.name as Roles) === Roles.SUPER_ADMIN ||
    (user?.role?.name as Roles) === Roles.GENERAL_ADMIN
  );
};

/**
 * Check if the current user has a specific role
 * @param user - The user object from Redux state
 * @param role - The role to check against
 * @returns true if user has the specified role, false otherwise
 */
export const hasRole = (user: TUser | null, role: Roles): boolean => {
  return (user?.role?.name as Roles) === role;
};

/**
 * Check if the current user has any of the specified roles
 * @param user - The user object from Redux state
 * @param roles - Array of roles to check against
 * @returns true if user has any of the specified roles, false otherwise
 */
export const hasAnyRole = (user: TUser | null, roles: Roles[]): boolean => {
  const userRole = user?.role?.name as Roles;
  return roles.includes(userRole);
};
